const INTELLIWRITER_AUTH_BRIDGE_ORIGIN =
  process.env.REACT_APP_INTELLIWRITER_AUTH_BRIDGE_ORIGIN;

export function notifyIntelliWriterAuthBridge(message: unknown): boolean {
  if (!window.opener || !INTELLIWRITER_AUTH_BRIDGE_ORIGIN) {
    return false;
  }

  window.opener.postMessage(message, INTELLIWRITER_AUTH_BRIDGE_ORIGIN);
  return true;
}
